<template lang='pug'>
	div(class="kt-spinner")
		span Loading {{p_txt}}... 
		span(class="spinner")
</template>

<script>
export default {
	name: "kt-spinner",
	props: {
		p_txt: String,
	},
};
</script>

<style lang="less">
.kt-spinner {
	padding: 1em 0;
	text-align: center;
	@keyframes spinner {
		100% {
			transform: rotate(360deg);
		}
	}

	span:first-child {
		font-size: 16px;
	}
	span:last-child {
		color: #4fa4ff;
		border-width: 0.2em;
		display: inline-block;
		width: 1.3rem;
		height: 1.3rem;
		vertical-align: middle;
		border: 0.25em solid currentColor;
		border-right-color: transparent;
		border-radius: 50%;
		-webkit-animation: spinner 0.75s linear infinite;
		animation: spinner 0.75s linear infinite;
	}
}
</style>